import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _typeof from "@babel/runtime/helpers/typeof";

var _templateObject;

import "core-js/modules/es6.array.map.js";
import React from 'react';
import StructuredContent from '@nerdwallet/structured-content';
import { gql } from '@nerdwallet/apollo';
import { VALUE_SIZES } from '@nerdwallet/marketplace/constants/drivers';
import ContentSanitizer from '../../content-sanitizer';
/**
 * Safe property check.
 */

var hasOwnProperty = function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};
/**
 * Simple heuristic for determining whether an entity should be wrapped in <StructuredContent />.
 */


var isStructuredContentDoc = function isStructuredContentDoc(entity) {
  return entity && _typeof(entity) === 'object' && hasOwnProperty(entity, 'version') && hasOwnProperty(entity, 'type') && hasOwnProperty(entity, 'props');
};
/**
 * Check against type 'string' to match the underlying
 * html-react-parser lib. Additionally, this ensures we render both
 * single React elements as well as arrays of React elements.
 * Additional param propertyThatUsesHttp used to override anchor element in content-sanitizer
 * @see {@link https://github.com/remarkablemark/html-react-parser/blob/master/index.js#L16}
 */


export var sanitizeNode = function sanitizeNode(node) {
  var respectUnsafeHref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return typeof node !== 'string' ? node : /*#__PURE__*/React.createElement(ContentSanitizer, {
    html: node,
    respectUnsafeHref: respectUnsafeHref
  });
};
/**
 * Safely render nil values, structured content docs, and react nodes alike.
 */

export var safeStructuredContentRender = function safeStructuredContentRender(doc) {
  if (doc == null) {
    return null;
  }

  if (isStructuredContentDoc(doc)) {
    return /*#__PURE__*/React.createElement(StructuredContent, {
      key: JSON.stringify(doc)
    }, doc);
  }

  return doc;
};
/**
 * Safely render an array of nullable structured content docs.
 */

export var safeStructuredContentArrayRender = function safeStructuredContentArrayRender(docs) {
  return Array.isArray(docs) ? docs.map(safeStructuredContentRender) : null;
};
/**
 * Safe transform of free form structured content
 */

export var safeRender = function safeRender(doc) {
  if (!doc) {
    return null;
  }

  if (Array.isArray(doc)) {
    return safeStructuredContentArrayRender(doc);
  }

  return safeStructuredContentRender(doc);
};
/**
 * Interface for quick fact configuration.
 * @todo - This should come from `@nerdwallet/react-quick-facts`.
 */

/**
 * Translate GraphQL sponsored drivers into the interface expected by `<QuickFacts />`.
 */
export var normalizeEntityPlacementDriver = function normalizeEntityPlacementDriver(placementDriver) {
  var valueTooltip;

  if (placementDriver.valueTooltip && placementDriver.valueTooltipHasHtml) {
    // Can't use sanitizeNode here because of Mortgages use of `table`

    /* eslint-disable react/no-danger */
    valueTooltip = /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: placementDriver.valueTooltip
      }
    });
    /* eslint-enable react/no-danger */
  } else {
    valueTooltip = placementDriver.valueTooltip;
  }

  return {
    description: safeStructuredContentRender(placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.description),
    id: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.label,
    label: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.label,
    labelTooltip: placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.labelTooltip,
    valueTooltip: valueTooltip,
    value: safeStructuredContentRender(placementDriver === null || placementDriver === void 0 ? void 0 : placementDriver.value),

    /** @todo - Should we standardize driver size? */
    valueSize: VALUE_SIZES.MEDIUM
  };
};
normalizeEntityPlacementDriver.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment normalizeEntityPlacementDriver on EntityPlacementDriver {\n    __typename\n    description\n    label\n    labelTooltip\n    value\n    valueTooltip\n    valueTooltipHasHtml\n  }\n"])));